var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"banner",attrs:{"src":require("@/assets/008.jpg"),"alt":"banner"}}),_c('img',{staticClass:"banner",attrs:{"src":require("@/assets/009.jpg"),"alt":"banner"}})])
}]

export { render, staticRenderFns }